export enum Role {
  Master = 'Master',
  Marshal = 'Marshal',
  Player = 'Player'
};

export interface User {
  _id: string,
  first: string,
  last: string,
  password?: string,
  email: string,
  role?: Role,
};
